import {Module} from "vuex";
import {RootState} from "@/store/types";
import {priorityRules} from "@/store/rules/priority_rules";
import {originatorRules} from "@/store/rules/originator_rules";

export const rulesModule: Module<any, RootState> = {
  modules: {
    originatorRules,
    priorityRules
  }
}
